"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObjectBuilderNode = void 0;
const BaseNode_1 = require("../../BaseNode");
const Schema = __importStar(require("./schema.json"));
const NODE_TYPE = 'OBJECT-BUILDER';
class ObjectBuilderNode extends BaseNode_1.BaseNode {
    constructor() {
        super(...arguments);
        this._resolve = (params) => {
            // Basically, build an object out of all of our inputs and return it...
            // The one caveat is we can't return 'undefined' items
            const outputObject = {};
            Object.keys(params).forEach((key) => {
                if (params[key] !== undefined) {
                    outputObject[key] = params[key];
                }
            });
            return outputObject;
        };
        //TODO: Build the interface definition from the given schema....but what is our schema
        this._interfaceDefinition = Schema;
    }
    // we override the schema definition here so that we can provide it based on the selected value
    get interfaceDefinition() {
        var _a;
        // grab the input schema from our schema loader
        const inputSchema = this.schemaLookup.getSchema((_a = this.config) === null || _a === void 0 ? void 0 : _a.objectSchema) || {};
        return Object.assign(Object.assign({}, Schema), { InputParams: inputSchema });
    }
}
exports.ObjectBuilderNode = ObjectBuilderNode;
ObjectBuilderNode._nodeDefinition = {
    NODE_TYPE,
    defaultTitle: 'Object Builder',
    isIdempotent: true,
    primaryCategory: 'Object Creation',
};
//# sourceMappingURL=ObjectBuilder.js.map